import React, { useEffect, useRef } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "./Tooltip.scss";

const Tooltip = ({
  children,
  className = "",
  variant = "dark",
  hideOnScroll = false,
  appendTo = () => document.body,
  onShow,
  onHide,
  ...tippyProps
}) => {
  const scrollHandlerRef = useRef(null);

  const removeScrollListeners = () => {
    if (!scrollHandlerRef.current) return;
    window.removeEventListener("scroll", scrollHandlerRef.current, true);
    window.removeEventListener("resize", scrollHandlerRef.current);
    scrollHandlerRef.current = null;
  };

  useEffect(() => removeScrollListeners, []);

  return (
    <Tippy
      {...tippyProps}
      className={`ai-tooltip ai-tooltip--${variant} ${className}`.trim()}
      appendTo={appendTo}
      onShow={(instance) => {
        onShow?.(instance);
        if (!hideOnScroll) return;
        removeScrollListeners();
        const handler = () => instance.hide();
        scrollHandlerRef.current = handler;
        window.addEventListener("scroll", handler, true);
        window.addEventListener("resize", handler);
      }}
      onHide={(instance) => {
        onHide?.(instance);
        removeScrollListeners();
      }}
    >
      {children}
    </Tippy>
  );
};

export default Tooltip;
